import { render, staticRenderFns } from "./DataSourceSetting.vue?vue&type=template&id=4a68433f"
import script from "./DataSourceSetting.vue?vue&type=script&lang=js"
export * from "./DataSourceSetting.vue?vue&type=script&lang=js"
import style0 from "./DataSourceSetting.vue?vue&type=style&index=0&id=4a68433f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports